<div class="body-tiss-guide">
  <div class="title-header">
    <h1>Gerenciamento de Guias TISS</h1>
    <div class="col-12 col-sm-4">
      @if (isFirstLoading) {
        <app-loading-progress-bar></app-loading-progress-bar>
      }
      @if (!this.isFirstLoading) {
        <mat-form-field appearance="outline">
          <mat-label>Nova guia TISS</mat-label>
          <mat-select [(ngModel)]="tissGuide" (selectionChange)="choiceGuide()">
            @for (item of listTissGuide; track item) {
              <mat-option [value]="item.idGuideType"
                [disabled]="isListPopulated(item.idGuideType)">
                {{item.guideName}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  </div>
  @if (!isLoading) {
    <div class="row">
      <h2>Guias Geradas</h2>
      <div class="guide-container">
        @for (admissionGuide of listAdmissionGuideStruct; track admissionGuide) {
          <div class="border-box">
            <a (click)="selectGuide(admissionGuide, this.admissionGuideEnum)">
              <div class="spacing-data">
                <span><strong>Guia nº {{ admissionGuide.guide.guideNumber }} - </strong>
                {{ admissionGuide?.admissionGuide?.requesterName ?? "Sem contratado executante definido" }}
              </span>
              <span>Internação</span>
            </div>
            <div [style.color]="getGuideColor(admissionGuide.guide.idGuideStatus)">
              <span>{{ getGuideName(admissionGuide.guide.idGuideStatus) }}</span>
              @if (!isAttendance || (admissionGuide.guide.idGuide && !admissionGuide.hasAlteration && isAttendance)) {
                <span
                class="secundary tag-saved" matTooltip="Esta guia foi salva corretamente">Guia Salva</span>
              }
              @if (isAttendance && (!admissionGuide.guide.idGuide || (admissionGuide.guide.idGuide && admissionGuide.hasAlteration))) {
                <span
                class="secundary tag-not-saved" matTooltip="Esta guia ainda não está salva porque o atendimento não foi finalizado">Guia Pendente</span>
              }
            </div>
          </a>
          <div class="actions">
            @if (!isAttendance || (admissionGuide.guide.idGuide && !admissionGuide.hasAlteration && isAttendance)) {
              <a><mat-icon aria-hidden="false" aria-label="Editar" (click)="print(admissionGuide)">print</mat-icon></a>
            }
          </div>
        </div>
      }
      @for (appointmentGuide of listAppointmentGuideStruct; track appointmentGuide) {
        <div class="border-box">
          <a (click)="selectGuide(appointmentGuide, this.appointmentGuideEnum)">
            <div class="spacing-data">
              <span>
                <strong>Guia nº {{ appointmentGuide.guide ? appointmentGuide.guide.guideNumber :
                appointmentGuide.guideNumber }} - </strong>
                {{ appointmentGuide?.appointmentGuide?.contractorName ?? "Sem contratado executante definido" }}
              </span>
              <span>Consulta</span>
            </div>
            <div
              [style.color]="getGuideColor(appointmentGuide.guide ? appointmentGuide.guide.idGuideStatus : appointmentGuide.idGuideStatus)">
              <span>{{ getGuideName(appointmentGuide.guide ? appointmentGuide.guide.idGuideStatus :
              appointmentGuide.idGuideStatus) }}</span>
              @if (!isAttendance || (appointmentGuide.guide.idGuide && !appointmentGuide.hasAlteration && isAttendance)) {
                <span
                class="secundary tag-saved" matTooltip="Esta guia foi salva corretamente">Guia Salva</span>
              }
              @if (isAttendance && (!appointmentGuide.guide.idGuide || (appointmentGuide.guide.idGuide && appointmentGuide.hasAlteration))) {
                <span
                class="secundary tag-not-saved" matTooltip="Esta guia ainda não está salva porque o atendimento não foi finalizado">Guia Pendente</span>
              }
            </div>
          </a>
          <div class="actions">
            @if (!isAttendance || (appointmentGuide.guide.idGuide && !appointmentGuide.hasAlteration && isAttendance)) {
              <a><mat-icon aria-hidden="false" aria-label="Editar" (click)="print(appointmentGuide)">print</mat-icon></a>
            }
          </div>
        </div>
      }
      @for (spSadtGuide of listSpSadtGuideStruct; track spSadtGuide) {
        <div class="border-box">
          <a (click)="selectGuide(spSadtGuide, this.spSadtGuideEnum)">
            <div class="spacing-data">
              <span>
                <strong>Guia nº {{ spSadtGuide.guide.guideNumber }} - </strong>
                {{ spSadtGuide?.spSadtGuide?.executantContractorName ?? "Sem contratado executante definido" }}
              </span>
              <span>SP/SADT</span>
            </div>
            <div [style.color]="getGuideColor(spSadtGuide.guide.idGuideStatus)">
              <span>{{ getGuideName(spSadtGuide.guide.idGuideStatus) }}</span>
              @if (!isAttendance || (spSadtGuide.guide.idGuide && !spSadtGuide.hasAlteration && isAttendance)) {
                <span
                class="secundary tag-saved" matTooltip="Esta guia foi salva corretamente">Guia Salva</span>
              }
              @if (isAttendance && (!spSadtGuide.guide.idGuide || (spSadtGuide.guide.idGuide && spSadtGuide.hasAlteration))) {
                <span
                class="secundary tag-not-saved" matTooltip="Esta guia ainda não está salva porque o atendimento não foi finalizado">Guia Pendente</span>
              }
            </div>
          </a>
          <div class="actions">
            @if (!isAttendance || (spSadtGuide.guide.idGuide && !spSadtGuide.hasAlteration && isAttendance)) {
              <a><mat-icon aria-hidden="false" aria-label="Editar" (click)="print(spSadtGuide)">print</mat-icon></a>
            }
          </div>
        </div>
      }
      @for (feesGuide of listFeesGuideStruct; track feesGuide) {
        <div class="border-box">
          <a (click)="selectGuide(feesGuide, this.feesGuideEnum)">
            <div class="spacing-data">
              <span>
                <strong>Guia nº {{ feesGuide.guide.guideNumber }} - </strong>
                {{ feesGuide?.feesGuide?.executantName ?? "Sem contratado executante definido" }}
              </span>
              <span>Honorários</span>
            </div>
            <div [style.color]="getGuideColor(feesGuide.guide.idGuideStatus)">
              <span>{{ getGuideName(feesGuide.guide.idGuideStatus) }}</span>
              @if (!isAttendance || (feesGuide.guide.idGuide && !feesGuide.hasAlteration && isAttendance)) {
                <span
                class="secundary tag-saved" matTooltip="Esta guia foi salva corretamente">Guia Salva</span>
              }
              @if (isAttendance && (!feesGuide.guide.idGuide || (feesGuide.guide.idGuide && feesGuide.hasAlteration))) {
                <span
                class="secundary tag-not-saved" matTooltip="Esta guia ainda não está salva porque o atendimento não foi finalizado">Guia Pendente</span>
              }
            </div>
          </a>
          <div class="actions">
            @if (!isAttendance || (feesGuide.guide.idGuide && !feesGuide.hasAlteration && isAttendance)) {
              <a><mat-icon aria-hidden="false" aria-label="Editar" (click)="print(feesGuide)">print</mat-icon></a>
            }
          </div>
        </div>
      }
      @if (!isLoading && listAdmissionGuideStruct != undefined  && listAdmissionGuideStruct.length == 0 &&
        listFeesGuideStruct != undefined && listFeesGuideStruct.length == 0 &&
        listSpSadtGuideStruct != undefined && listSpSadtGuideStruct.length == 0 &&
        listAppointmentGuideStruct != undefined && listAppointmentGuideStruct.length == 0) {
        <app-empty-list>
        </app-empty-list>
      }
    </div>
  </div>
}
@if (isLoading) {
  <app-loading-list></app-loading-list>
}
</div>